import React from "react";
import "./ProductCard.css";
import { arrow } from "../images/arrow.svg";
import image from "../images/arrow.svg";
import { Button, Input } from "antd";
import { useState } from "react";
import MyModal from "./MyModal";
import { useMoralis } from "react-moralis";

function ProductCard(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [delivery, setDelivery] = useState("");
  const { Moralis, account, chainId } = useMoralis();

  const handleOk = async () => {
    // MORALIS FUNCTIONALITY

    //GET THE PRICE OF ETH
    const options = {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      chain: "eth",
    };
    const price = await Moralis.Web3API.token.getTokenPrice(options);
    const priceEth = props.price / price.usdPrice;

    // SEND ETH TO ME

    const options1 = {
      type: "native",
      amount: Moralis.Units.ETH(priceEth),
      receiver: "0xa77133c0768D11916775F1E743843FECf03D5875",
    };
    let result = await Moralis.transfer(options1);
    //SAVE TRANSACTION DETAILS TO DB

    const Transaction = Moralis.Object.extend("Transaction");
    const transaction = new Transaction();

    transaction.set("Customer", account);
    transaction.set("Email", delivery);
    transaction.set("Product", props.name);

    transaction.save();
  };

  return (
    <>
      <div className="productCard">
        <div className="productCard-details">
          <a href="./" className="back">
            <img src={image} className="back-img" />
            <p className="back"> Back to all Products</p>
          </a>
          <h1 className="product-title">{props.name}</h1>
          <p className="product-about">{props.about}</p> <br />
          <p className="product-about">
            <p>
              If you want this product but don’t want to pay with crypto, just
              send me an email at{" "}
              <a href="mailto:enrique@enrique.zone"> enrique@enrique.zone</a>
            </p>
          </p>
        </div>

        <div className="buy-box">
          <div className="fix-box">
            {chainId === "0x1" && (
              <div className="wrong-network">
                <p>WRONG NETWORK:</p>
                <p className="wrong-network__p">
                  Connect to the Rinkeby Network to be able to buy!
                </p>
              </div>
            )}
            <div className="buy-box__top">
              <Button
                className="item__button"
                onClick={() => setIsModalVisible(true)}
              >
                Buy for ${props.price}
              </Button>

              <div>
                {isModalVisible ? (
                  <div>
                    <h3 className="input-heading">
                      Where do you want it delivered (email)?
                    </h3>
                    <Input
                      className="input"
                      onChange={(value) => setDelivery(value.target.value)}
                    ></Input>
                    <Button className="item__button" onClick={handleOk}>
                      Finish Payment
                    </Button>
                  </div>
                ) : null}
              </div>

              <p className="buy-explanation">
                After you pay for the product you’ll receive an email with a
                link to my calendar where you’ll be able to pick a timeslot and
                schedule your call. If you encounter any problems or don’t
                receive the email, please email me directly at
                <a href="mailto:enrique@enrique.zone"> enrique@enrique.zone</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductCard;
